/*
 * @author BSG <dev@bsgroup.eu>
 * @copyright Better Software Group S.A.
 * @version: 1.0
 */

import React from "react";

import { usePlayerTranslation } from "../../../../../../shared/context/PlayerTranslationContext";
import CommentatorIcon from "../../../../../../shared/icons/player/Commentator.svg";
import { usePlayerSettings } from "../../../../../BasePlayer";
import { usePlayerCurrentMedia } from "../../../../../Controller";
import { useOverlayState } from "../../../../../Overlay";
import { DropdownMenu, ToggleButton } from "../../../../Base";

import { PlayList } from "./PlayList";

export const PlayListButton = () => {
  const { t } = usePlayerTranslation();
  const { playInfo } = usePlayerCurrentMedia();

  const {
    ui: { tooltipOffset },
  } = usePlayerSettings();

  const { toggleSettings } = useOverlayState();

  if (!playInfo?.Playlist || playInfo?.Playlist?.length <= 1) {
    return null;
  }

  return (
    <ToggleButton
      variant="secondary"
      icon={<CommentatorIcon aria-hidden="true" focusable="false" />}
      tooltip={t("PLAYER_PLAYLIST_BUTTON_TITLE")}
      tooltipOffset={tooltipOffset}
      onVisibilityChange={toggleSettings}
      iconOnly
    >
      <DropdownMenu defaultSection="playlist">
        <PlayList />
      </DropdownMenu>
    </ToggleButton>
  );
};
